import React from 'react'

export default function StepPayment() {
  return (
    <div>
      payment order
    </div>
  )
}
